module.exports = "https://static.energy5.com/_next/static/images/brand11-84bc39c7069e89021a398ef0a3f8d977.png";